import { useMemo, useState } from 'react';

import { hasModule, ia, inRn } from 'lib/helpers/utility';

import Switch from 'components/shared/Switch/Switch';
import Transition from 'components/shared/Transition/Transition';
import Typography from 'components/shared/Typography/Typography';
import InvoiceSummary from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceFooter/InvoiceSummary/InvoiceSummary';
import { getProceduresTotal } from 'components/practice/BeyondBilling/ElectronicInvoicing/components/Invoice/components/InvoiceFooter/InvoiceSummary/lib/helpers';

import { INFORMATION_ITEMS } from '../../lib/constants';

import Invoices from './Invoices';
import InformationItem from './InformationItem';

const InvoiceDetails = ({ invoice }) => {
  const [showInvoiceDetails, setShowInvoiceDetails] = useState(true);
  const internalInvoices = invoice?.internal_invoices || [];
  const hiddenFields = invoice?.hidden_fields || [];

  const isAEOB = invoice?.aeob;
  const isGFE = invoice?.status === 'GFE';
  const hasClaims = hasModule(invoice?.practice?.modules, 'billing.claims');

  const totals = useMemo(
    () => getProceduresTotal({ invoices: internalInvoices, show: true, isAEOB }),
    [internalInvoices, isAEOB]
  );

  const surchargeAmount = inRn(invoice?.surcharge_amount);

  const {
    tax = 0,
    discount = 0,
    amount_paid = 0,
    ins_payment = 0,
    ins_adjustment = 0,
    other_adj = 0,
    write_off = 0,
    local_tax = 0,
    state_tax = 0,
    total = 0,
    subTotal = 0
  } = totals || {};

  const isPaid = !!invoice?.paid;
  const totalWithSurcharge = total + (!isPaid ? surchargeAmount : 0);

  return (
    <>
      <div className="flex justify-between gap-3 border-0 border-y border-solid border-neutral-200 px-6 py-3 sm:flex-col sm:px-2">
        <div className="flex flex-col gap-2">
          {INFORMATION_ITEMS.map((item) => (
            <InformationItem key={item.text} {...item} />
          ))}
        </div>
        {ia(internalInvoices) && (
          <div className="flex items-start gap-1.5">
            <Switch checked={showInvoiceDetails} onChange={setShowInvoiceDetails} />
            <Typography variant="label" size="small" weight="medium" color="neutral-700">
              Show invoice details
            </Typography>
          </div>
        )}
      </div>
      <Transition
        isOpen={showInvoiceDetails}
        type="slide-down"
        duration={{ enter: 300, leave: 300 }}>
        <div className="py-4 sm:py-0">
          <Invoices invoices={internalInvoices} hiddenFields={hiddenFields} claims={hasClaims} />
          <InvoiceSummary
            total={totalWithSurcharge}
            subTotal={subTotal}
            technologyFee={surchargeAmount}
            stateTax={state_tax}
            localTax={local_tax}
            discount={discount}
            writeOffs={write_off}
            otherAdjustments={other_adj}
            insuranceAdjustments={ins_adjustment}
            claimsPermissions={hasClaims}
            hideSwitch
            tax={tax}
            patientPaid={amount_paid}
            insurancePaid={ins_payment}
            isAEOB={isAEOB}
            isGFE={isGFE}
          />
        </div>
      </Transition>
    </>
  );
};

export default InvoiceDetails;
